module.exports = __webpack_public_path__ + "static/media/twitter.cb73c309.png";